<template>
  <section>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-4 has-background-white is-paddingless">
        <div class="hero is-fullheight mx-82">
          <div class="mt-120">
            <div class="has-text-centered mb-4px0">
              <img src="@/assets/images/accueilLogo.svg">
            </div>
            <msgError
              v-if="isError"
              type="is-danger"
              :msg="$t('connexion.messageError')"
              @close="isError = false"/>
            <form @submit.prevent="login({site, identifiant, password })">
              <b-field label="Site" custom-class="has-text-default is-size-7">
          <b-input  type="text"  v-model="site"/>
        </b-field>
              <b-field
                custom-class="has-text-default is-size-7"
                :label="$t('connexion.titleIdentifiant')">
                <b-input type="text" name="username" v-model="identifiant"/>
              </b-field>
              <b-field custom-class="has-text-default pt-20 is-size-7" :label="$t('connexion.titlePassword')">
                <b-input type="password" v-model="password"/>
              </b-field>
              <div class="pt-20">
                <button class="has-text-weight-bold button is-primary is-fullwidth" type="submit">
                  {{$t('connexion.buttonLogin')}}
                </button>
              </div>
            </form>
          </div>
          <div class="mb-20 left-align has-text-default is-size-8">
            <span>{{$t('connexion.textEditor')}}</span>
          </div>
        </div>
      </div>
      <div class="column is-paddingless">
        <div class="hero is-fullheight is-position-relative">
          <div>
            <div class="sizeImage" :style="imageConnexionCss"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { auth } from '@/plugins/firebase';
import getImageConnexion from '@/api/imageConnexion';
import backgroundLogin from '@/assets/images/pageConnexion/Background-login-default.png';
import { auth as authSuivi } from '@/plugins/firebaseSuivi';
import { PAGE_DEFAULT } from '@/router/routerConf';
import { EMAIL, PASSWORD, PASSWORD_SUIVI } from '@/configuration/firebase';
import { DOMAINE } from '@/configuration/paramsAffixe2';
import msgError from '@/components/general/messageErreur';
import gestionErreur from '@/services/general/gestionErreur';

const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    msgError,
  },
  data() {
    return {
      identifiant: '',
      password: '',
      site: '',
      isError: false,
      imageUrl: null,
      isFetchingImage: false,
    };
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    imageConnexionCss() {
      let url = backgroundLogin;
      if (this.isFetchingImage) url = '';
      else if (this.imageUrl) url = this.imageUrl;
      return { 'background-image': `url(${url})` };
    },
  },
  methods: {
    ...User.mapActions({
      actionsLogIn: 'logIn',
      actionLogOut: 'logOut',
    }),
    ...Societe.mapActions({
      actionsLoadSocietes: 'loadSocietes',
    }),
    async login() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.identifiant = this.identifiant.toLowerCase();
        this.site = this.site.toLowerCase();
        await this.actionsLogIn({ email: this.identifiant,
          password: this.password,
          site: this.site,
        });
        if (this.user.domaine === DOMAINE) {
          await this.actionLogOut();
          this.$buefy.toast.open({
            message: this.$t('connexion.infoConnexionPortail'),
            type: 'is-danger'});
          return;
        }
        await auth.signInWithEmailAndPassword(EMAIL, PASSWORD);
        await authSuivi.signInWithEmailAndPassword(EMAIL, PASSWORD_SUIVI);
        await this.actionsLoadSocietes();
        this.isError = false;
        this.$router.push(PAGE_DEFAULT);
      } catch (error) {
        gestionErreur('Erreur lors de connexion', error);
        this.isError = true;
      } finally {
        loadingComponent.close();
      }
    },
    async loadImage() {
      this.isFetchingImage = true;
      try {
        // Le chargement de l'image ne doit pas être bloquant
        const response = await getImageConnexion();
        if (response.data && response.data.result) {
          this.imageUrl = response.data.result.chemin;
        }
      } catch (e) {
        console.warn('Image de connexion indisponible', e);
      } finally {
        this.isFetchingImage = false;
      }
    },
  },
  mounted() {
    this.loadImage();
  },
};
</script>
